
































import { Component, Vue, Prop } from "vue-property-decorator"
@Component({
    name: 'crop-image'
})
export default class CropImageComponent extends Vue {
    @Prop() type: string;    
    @Prop() aspectRatio: number;
    @Prop() imageSrc: string;
    @Prop() maxHeight: number;
    @Prop() maxWidth: number;
    @Prop() height: number;
    @Prop() width: number;
    @Prop({default: false}) isLiveUpdate: boolean;
    @Prop({default: () => { return { 
                        left: 0,
                        top: 0,
                        height: 0,
                        width: 0
                    }}}) prevParams: PrevParams;
    realWidth = 0;
    realHeight = 0;    
    loaded(data: any){
        (this.$refs.frame as any).show(data);
        this.realHeight = data.height;
        this.realWidth = data.width;
    }
    getCropParams(){
        this.$emit('height', this.realHeight);
        return (this.$refs.frame as any).getParams(); 
    }
    forceUpdate() {
        (this.$refs.frame as any).forceUpdate();
    }
    updateCropParams(data: any){ 
        this.$emit('update', data);
    }
    
};
export interface PrevParams {
    left: number;
    top: number;
    height: number;
    width: number;
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-components/~/crop-image/src/crop-image.vue